import { millisecondsToMinutes, minutesToHours } from "date-fns";

export const calculateTimeAgo = (dateString?: string): string[] | undefined => {
  if (!dateString) return;

  const lastDate = new Date(dateString);
  const currentDate = new Date();
  const differenceInMs = currentDate.getTime() - lastDate.getTime();

  const minutes = millisecondsToMinutes(differenceInMs);
  const hours = minutesToHours(minutes);
  const days = Math.floor(hours / 24);

  if (minutes < 1 && days === 0 && hours === 0) {
    return ["less than a minute"];
  }

  if (days === 0 && hours === 0 && minutes < 60) {
    return [`${minutes} minute${minutes !== 1 ? "s" : ""}`];
  }

  if (days === 0 && hours) {
    return [`${hours} hour${hours !== 1 ? "s" : ""}`];
  }

  return [
    days ? `${days} day${days !== 1 ? "s" : ""}` : "",
    hours ? `${hours} hour${hours !== 1 ? "s" : ""}` : "",
  ];
};
